<template>
  <fou-accordion>
    <slot />
  </fou-accordion>
</template>

<script type="text/ecmascript-6">
import FouAccordion from 'components/tools/fou-accordion/'

export default {
  name: 'ValidationList',

  components: {
    FouAccordion
  }
}
</script>
